import React from 'react';
import { RequestPasswordResetForm } from 'components';

export const RequestPasswordReset = () => {
	return <RequestPasswordResetForm />;
}
